import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EnhancedTable from '../Common/Table/EnhancedTable';
import IdentityService from '../../apiclients/IdentityService';

let USER_CACHE = {};

class ReadLogs extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
        this.getUsersData();
    }

    getUsersData = async () => {
        let userSubsQuery = [];

        let processedUserSubs = [];
        let readList = [];
        if (this.props.notification.readList) {
            readList = this.props.notification.readList;
        }
        readList.forEach((element) => {
            if (processedUserSubs.indexOf(element.userSub) === -1) {
                processedUserSubs.push(element.userSub);
            }
        });

        processedUserSubs.forEach((currentUserSub) => {
            let currResponse;
            if (USER_CACHE[currentUserSub]) {
                // console.log('user cache hit');
                currResponse = Promise.resolve(USER_CACHE[currentUserSub]);
            } else {
                // console.log('user cache miss');
                currResponse = IdentityService.getUser(
                    currentUserSub
                ).then((data) => {
                    return data;
                });
            }
            userSubsQuery.push(currResponse);
        });
        let results = await Promise.all(userSubsQuery).catch((err) => {
            console.log(err.message);
            return [];
        });

        let usersData = {};
        results.forEach((item) => {
            USER_CACHE[item.userSub] = item;
            usersData[item.userSub] = item;
        });

        this.setState({ usersData });
    };

    render() {
        if (this.state.usersData === undefined) {
            return <div />;
        }
        const columns = [
            {
                name: 'User', id: 'userSub', isSortable: true, numeric: false, disablePadding: false, render: (element) => {
                    return ((element.userSub && this.state.usersData && this.state.usersData[element.userSub]) ? this.state.usersData[element.userSub].name : '');
                }
            },
            { name: 'Date', id: 'date', isSortable: true, numeric: false, disablePadding: false, isDate: true },
        ];

        let readList = [];
        let totalSent = 0;

        if (this.props.notification.readList) {
            readList = this.props.notification.readList;
        }
        if (this.props.notification.totalSent) {
            totalSent = this.props.notification.totalSent;
        }

        return (
            <EnhancedTable
                tableTitle={`Notification Status  - ${readList.length} read out of ${totalSent}`}
                showSelectors={false}
                data={readList}
                columnData={columns}
                rowId={'userSub'}
                //loadMore={this.state.lastKey !== undefined ? this.loadMore : undefined}
                onItemClick={() => { }}
                actions={[]}
            />
        );
    }
}
ReadLogs.propTypes = {
    notification: PropTypes.object.isRequired,
};

export default ReadLogs;
